import { erroPeriodoConsulta } from '../../../core/tools/periodo-consulta';
import { Component, OnInit } from '@angular/core';
import { Animacao } from '../../../core/tools/animacao';
import { Cliente } from '../../../core/models/clientes/cliente';
import { Produto } from '../../../core/models/produtos/produto';
import { Vendedor } from '../../../core/models/vendedores/vendedor';
import { ClienteService } from '../../../core/services/clientes/cliente.service';
import {
  DashboardResultadosCidade,
  DashboardResultadosReativacoes,
  SankhyaMetaLinha,
  DashboardResultadosAberturaCliente,
  DashboardResultadosCliente,
  DashboardResultadosDia,
  DashboardResultadosFiltroGrupoRelacao,
  DashboardResultadosRequest,
  DashboardResultadosMeta,
  DashboardResultadosPositivacaoCliente,
  DashboardResultadosProduto,
  DashboardResultadosVendasCanal,
  DashboardResultadosService
} from '../../../core/services/dashboard/resultados/dashboard-resultados.service';
import { ProdutoService } from '../../../core/services/produtos/produto.service';
import { VendedorService } from '../../../core/services/vendedores/vendedor.service';

@Component({
  selector: 'app-dashboard-resultados',
  templateUrl: './dashboard-resultados.component.html',
  styleUrls: ['./dashboard-resultados.component.css'],
  preserveWhitespaces: false,
  animations: [Animacao],
  standalone: false
})
export class DashboardResultadosComponent implements OnInit {
  erroPeriodo = '';
  abaAtiva: 'resultados' | 'positivacao' | 'reativacoes' | 'abertura' = 'resultados';
  abas = [
    { id: 'resultados' as const, titulo: 'Resultados', icone: 'fa-line-chart' },
    { id: 'positivacao' as const, titulo: 'Positivação', icone: 'fa-check-square-o' },
    { id: 'reativacoes' as const, titulo: 'Reativações', icone: 'fa-refresh' },
    { id: 'abertura' as const, titulo: 'Abertura Clientes', icone: 'fa-user-plus' }
  ];
  reativacoes: DashboardResultadosReativacoes = null;
  reativacoesCarregando = false;
  reativacoesErro = '';
  reativacoesInicio: string;
  reativacoesFim: string;
  reativacoesVendedorId: number = null;
  reativacoesRegiao = '';
  reativacoesPagina = 1;
  readonly reativacoesPorPagina = 25;
  private reativacoesConsulta = 0;

  selecionarAba(aba: typeof this.abaAtiva) {
    if (this.abaAtiva === aba) return;
    this.abaAtiva = aba;
    this.filtroAtivo = '';
    this.grupoFiltroAtivo = '';
    this.atualizar();
  }

  get reativacoesTotalPaginas(): number {
    return Math.max(1, Math.ceil((this.reativacoes?.clientes.length || 0) / this.reativacoesPorPagina));
  }

  get reativacoesLinhas() {
    const inicio = (this.reativacoesPagina - 1) * this.reativacoesPorPagina;
    return (this.reativacoes?.clientes || []).slice(inicio, inicio + this.reativacoesPorPagina);
  }

  carregarReativacoes() {
    const consulta = ++this.reativacoesConsulta;
    this.reativacoesErro = '';
    if (erroPeriodoConsulta(this.reativacoesInicio, this.reativacoesFim)) {
      this.reativacoes = null;
      this.reativacoesCarregando = false;
      this.reativacoesErro = erroPeriodoConsulta(this.reativacoesInicio, this.reativacoesFim);
      return;
    }
    this.reativacoesCarregando = true;
    this.reativacoesPagina = 1;
    const request = this.criarRequest();
    request.dataInicio = this.reativacoesInicio;
    request.dataFim = this.reativacoesFim;
    request.sellerId = this.reativacoesVendedorId;
    request.regiao = this.reativacoesRegiao || null;
    this.dashboardResultadosService.getReativacoes(request).subscribe({
      next: resultado => {
        if (consulta !== this.reativacoesConsulta) return;
        this.reativacoes = resultado;
        this.reativacoesCarregando = false;
      },
      error: erro => {
        if (consulta !== this.reativacoesConsulta) return;
        this.reativacoes = null;
        this.reativacoesCarregando = false;
        this.reativacoesErro = erro.status === 401 ? 'Entre novamente no portal para consultar as reativações.'
          : typeof erro.error === 'string' ? erro.error : 'Não foi possível carregar as reativações. Tente novamente.';
      }
    });
  }
  metasSankhyaPermitidas = ['769bf188-2b3f-4e8a-883d-ff13a3d705e2', '60fadf43-aaaa-4b91-b10c-e67fdd223861', '829d744b-23da-43da-9d58-f142cee25960'].includes((localStorage.getItem('guidclientenapis') || '').toLowerCase());
  metasSankhyaCarregando = false;
  metasSankhyaExibidas = false;
  metasSankhyaErro = '';
  metasSankhyaConsulta: string = null;
  mesesSankhya = this.criarMesesSankhya();
  mesSankhya = this.mesesSankhya[0].valor;

  private criarMesesSankhya(): { valor: string; descricao: string }[] {
    const partes = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit' }).formatToParts(new Date());
    const ano = Number(partes.find(p => p.type === 'year').value);
    const mes = Number(partes.find(p => p.type === 'month').value);
    return [0, 1, 2].map(i => {
      const data = new Date(Date.UTC(ano, mes - 1 - i, 1));
      return { valor: data.toISOString().slice(0, 7), descricao: data.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric', timeZone: 'UTC' }) };
    });
  }

  alterarMesSankhya() {
    this.metasSankhyaGrupos = [];
    this.metasSankhyaConsulta = null;
    this.metasSankhyaExibidas = false;
    this.metasSankhyaErro = '';
  }
  metasSankhyaGrupos: { codvend: number; vendedor: string; supervisor: string; regiao: string; linhas: SankhyaMetaLinha[] }[] = [];

  consultarMetasSankhya() {
    if (!this.metasSankhyaPermitidas || this.metasSankhyaCarregando) return;
    this.metasSankhyaCarregando = true;
    this.metasSankhyaErro = '';
    this.dashboardResultadosService.consultarMetasSankhya(Number(localStorage.getItem('id')), this.mesSankhya).subscribe({
      next: result => {
        const grupos = new Map<number, { codvend: number; vendedor: string; supervisor: string; regiao: string; linhas: SankhyaMetaLinha[] }>();
        for (const linha of result.linhas) {
          if (!grupos.has(linha.codvend)) grupos.set(linha.codvend, { codvend: linha.codvend, vendedor: linha.vendedor, supervisor: linha.supervisor, regiao: linha.regiao, linhas: [] });
          grupos.get(linha.codvend).linhas.push(linha);
        }
        this.metasSankhyaGrupos = Array.from(grupos.values()).sort((a,b) => a.codvend-b.codvend);
        this.metasSankhyaConsulta = result.consultadoEm;
        this.metasSankhyaExibidas = true;
        this.metasSankhyaCarregando = false;
      },
      error: err => {
        this.metasSankhyaErro = typeof err.error === 'string' ? err.error : 'Não foi possível consultar as metas. Tente novamente.';
        this.metasSankhyaCarregando = false;
      }
    });
  }

  formatarMetaSankhya(valor: number | null, codigo: number): string {
    if (valor == null) return '—';
    if (codigo === 17 || codigo === 22) return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    return valor.toLocaleString('pt-BR', { minimumFractionDigits: codigo === 21 ? 2 : 0, maximumFractionDigits: 2 }) + (codigo === 21 ? '%' : codigo === 23 ? ' L' : '');
  }

  larguraMetaSankhya(percentual: number | null): number { return Math.max(0, Math.min(100, percentual || 0)); }
  carregando: boolean = false;
  periodoDescricao: string = '';
  dataInicio: string;
  dataFim: string;
  ordenacaoProdutos: string = 'quantidade';
  ordenacaoClientes: string = 'valor';
  ordenacaoCidades: string = 'valor';
  tipoDados: 'FATURADO' | 'GERAL' = 'FATURADO';
  tipoPedidoFiltro = '';
  tiposPedidosDisponiveis: string[] = [];
  vendedorFiltro: string = '';
  clienteFiltro: string = '';
  produtoFiltro: string = '';
  grupoFiltro: string[] = [];
  grupo2Filtro: string[] = [];
  grupo3Filtro: string[] = [];
  vendedorFiltroId: number = null;
  clienteFiltroId: number = null;
  produtoFiltroId: number = null;
  filtroAtivo: string = '';
  grupoFiltroAtivo: string = '';
  exibirVendasCanais: boolean = false;
  metasAbertas: { [codigo: string]: boolean } = {};
  aberturaClientesAbertos: { [sellerId: number]: boolean } = {};
  aberturaClientesExibida: boolean = false;
  aberturaClientesCarregando: boolean = false;
  filtrosAplicados: DashboardResultadosRequest = null;

  vendedores: Vendedor[] = [];
  clientes: Cliente[] = [];
  produtosPesquisa: Produto[] = [];
  gruposDisponiveis: string[] = [];
  grupos2Disponiveis: string[] = [];
  grupos3Disponiveis: string[] = [];
  gruposRelacoes: DashboardResultadosFiltroGrupoRelacao[] = [];

  resultadosDias: DashboardResultadosDia[] = [];

  produtos: DashboardResultadosProduto[] = [];
  clientesRanking: DashboardResultadosCliente[] = [];
  cidadesRanking: DashboardResultadosCidade[] = [];
  vendasCanais: DashboardResultadosVendasCanal[] = [];
  positivacaoClientes: DashboardResultadosPositivacaoCliente[] = [];
  positivacaoClientesAtivos: DashboardResultadosPositivacaoCliente[] = [];
  aberturaClientes: DashboardResultadosAberturaCliente[] = [];

  metas: DashboardResultadosMeta[] = [];

  totalVendasReais: number = 0;
  totalVendasLitros: number = 0;
  totalPedidos: number = 0;
  ticketMedioGeral: number = 0;
  totalVendasExternas: number = 0;
  totalVendasInternas: number = 0;
  totalVendasCanais: number = 0;
  totalClientesPositivacao: number = 0;
  totalClientesPositivados: number = 0;
  percentualPositivacaoGeral: number = 0;
  totalClientesAtivosPositivacao: number = 0;
  totalClientesAtivosPositivados: number = 0;
  percentualPositivacaoAtivos: number = 0;
  totalAberturaClientes: number = 0;
  totalAberturaClientesValor: number = 0;

  maxVendasReais: number = 0;
  maxVendasLitros: number = 0;
  maxPedidos: number = 0;
  maxTicketMedio: number = 0;

  constructor(
    private dashboardResultadosService: DashboardResultadosService,
    private vendedorService: VendedorService,
    private clienteService: ClienteService,
    private produtoService: ProdutoService
  ) {
    const hoje = new Date();
    this.dataInicio = this.formatarDataApi(new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 6));
    this.dataFim = this.formatarDataApi(hoje);
    this.reativacoesInicio = this.dataInicio;
    this.reativacoesFim = this.dataFim;
  }

  ngOnInit() {
    this.carregarOpcoesPesquisa();
    this.carregarFiltroGrupos();
    this.atualizar();
  }

  atualizar() {
    if (this.abaAtiva === 'reativacoes') {
      this.carregarReativacoes();
      return;
    }

    this.erroPeriodo = erroPeriodoConsulta(this.dataInicio, this.dataFim);
    if (this.erroPeriodo) return;
    if (this.abaAtiva === 'abertura') {
      this.filtrosAplicados = this.copiarRequest(this.criarRequest());
      this.carregarAberturaClientes();
      return;
    }
    this.carregando = true;
    this.recolherAberturaClientes();
    this.periodoDescricao = this.getPeriodoDescricao();
    const request = this.criarRequest();
    this.filtrosAplicados = this.copiarRequest(request);

    this.dashboardResultadosService.getResumo(request).subscribe(resumo => {
      this.resultadosDias = resumo.dias || [];
      this.produtos = resumo.produtos || [];
      this.clientesRanking = resumo.clientes || [];
      this.cidadesRanking = resumo.cidades || [];
      this.vendasCanais = resumo.vendasCanais || [];
      this.positivacaoClientes = resumo.positivacaoClientes || [];
      this.positivacaoClientesAtivos = resumo.positivacaoClientesAtivos || [];
      this.metas = resumo.metas || [];
      this.calcularTotais();
      this.carregando = false;
    }, () => {
      this.carregando = false;
    });
  }

  carregarFiltroGrupos() {
    this.dashboardResultadosService.getFiltroGrupos(this.criarRequest()).subscribe(opcoes => {
      this.tiposPedidosDisponiveis = opcoes.tiposPedidos || [];
      // Um tipo sem resultados deve permanecer selecionado, nunca virar "Todos" silenciosamente.
      if (this.tipoPedidoFiltro && !this.tiposPedidosDisponiveis.includes(this.tipoPedidoFiltro)) {
        this.tiposPedidosDisponiveis = [this.tipoPedidoFiltro, ...this.tiposPedidosDisponiveis];
      }
      this.gruposDisponiveis = opcoes.grupos || [];
      this.gruposRelacoes = opcoes.relacoes || [];
      this.atualizarOpcoesGruposLocal();
    });
  }

  calcularTotais() {
    this.totalVendasReais = this.resultadosDias.reduce((sum, item) => sum + item.vendasReais, 0);
    this.totalVendasLitros = this.resultadosDias.reduce((sum, item) => sum + item.vendasLitros, 0);
    this.totalPedidos = this.resultadosDias.reduce((sum, item) => sum + item.pedidos, 0);
    this.ticketMedioGeral = this.totalPedidos > 0 ? this.totalVendasReais / this.totalPedidos : 0;
    this.totalVendasExternas = this.vendasCanais.reduce((sum, item) => sum + item.vendasExternas, 0);
    this.totalVendasInternas = this.vendasCanais.reduce((sum, item) => sum + item.vendasInternas, 0);
    this.totalVendasCanais = this.vendasCanais.reduce((sum, item) => sum + item.total, 0);
    this.totalClientesPositivacao = this.positivacaoClientes.reduce((sum, item) => sum + item.totalClientes, 0);
    this.totalClientesPositivados = this.positivacaoClientes.reduce((sum, item) => sum + item.positivacao, 0);
    this.percentualPositivacaoGeral = this.totalClientesPositivacao > 0
      ? (this.totalClientesPositivados / this.totalClientesPositivacao) * 100
      : 0;
    this.totalClientesAtivosPositivacao = this.positivacaoClientesAtivos.reduce((sum, item) => sum + item.totalClientes, 0);
    this.totalClientesAtivosPositivados = this.positivacaoClientesAtivos.reduce((sum, item) => sum + item.positivacao, 0);
    this.percentualPositivacaoAtivos = this.totalClientesAtivosPositivacao > 0
      ? (this.totalClientesAtivosPositivados / this.totalClientesAtivosPositivacao) * 100
      : 0;
    this.totalAberturaClientes = this.aberturaClientes.reduce((sum, item) => sum + item.totalClientes, 0);
    this.totalAberturaClientesValor = this.aberturaClientes.reduce((sum, item) => sum + item.valorFaturado, 0);

    this.maxVendasReais = Math.max(0, ...this.resultadosDias.map(item => item.vendasReais));
    this.maxVendasLitros = Math.max(0, ...this.resultadosDias.map(item => item.vendasLitros));
    this.maxPedidos = Math.max(0, ...this.resultadosDias.map(item => item.pedidos));
    this.maxTicketMedio = Math.max(0, ...this.resultadosDias.map(item => item.ticketMedio));
  }

  altura(valor: number, maximo: number): number {
    if (maximo <= 0) {
      return 0;
    }

    return Math.max((valor / maximo) * 100, 8);
  }

  largura(valor: number, maximo: number): number {
    if (maximo <= 0) {
      return 0;
    }

    return Math.max((valor / maximo) * 100, 6);
  }

  pontosTicketMedio(): string {
    if (this.resultadosDias.length == 0) {
      return '';
    }

    const espacamento = this.resultadosDias.length > 1 ? 90 / (this.resultadosDias.length - 1) : 0;

    return this.resultadosDias.map((item, index) => {
      let x = 5 + (index * espacamento);
      let y = 80 - this.altura(item.ticketMedio, this.maxTicketMedio) * 0.55;

      return `${x},${y}`;
    }).join(' ');
  }

  pontosTicketMedioDetalhe(): { x: number, y: number, valor: number, dia: string }[] {
    if (this.resultadosDias.length == 0) {
      return [];
    }

    const espacamento = this.resultadosDias.length > 1 ? 90 / (this.resultadosDias.length - 1) : 0;

    return this.resultadosDias.map((item, index) => {
      const x = 5 + (index * espacamento);
      const y = 80 - this.altura(item.ticketMedio, this.maxTicketMedio) * 0.55;

      return { x, y, valor: item.ticketMedio, dia: item.dia };
    });
  }

  resumoValor(valor: number): string {
    return valor.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
  }

  formatarMetaValor(meta: { tipo: string, localTipo: string }, valor: number): string {
    const numero = valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    if ((meta.localTipo || '').toUpperCase() == 'DEPOIS') {
      return `${numero} ${meta.tipo}`;
    }

    return `${meta.tipo} ${numero}`;
  }

  alternarMeta(meta: DashboardResultadosMeta) {
    this.metasAbertas[meta.codigo] = !this.metasAbertas[meta.codigo];
  }

  alternarAberturaClientes(item: DashboardResultadosAberturaCliente) {
    this.aberturaClientesAbertos[item.sellerId] = !this.aberturaClientesAbertos[item.sellerId];
  }

  alternarRelatorioAberturaClientes() {
    if (this.aberturaClientesExibida) {
      this.recolherAberturaClientes();
      return;
    }

    this.carregarAberturaClientes();
  }

  private aberturaConsulta = 0;

  private carregarAberturaClientes() {
    const consulta = ++this.aberturaConsulta;
    this.aberturaClientesExibida = true;
    this.aberturaClientesCarregando = true;
    this.aberturaClientesAbertos = {};
    const request = this.filtrosAplicados || this.criarRequest();
    this.dashboardResultadosService.getAberturaClientes(this.copiarRequest(request)).subscribe(resultado => {
      if (consulta !== this.aberturaConsulta) return;
      this.aberturaClientes = resultado || [];
      this.aberturaClientes.forEach(item => this.aberturaClientesAbertos[item.sellerId] = true);
      this.totalAberturaClientes = this.aberturaClientes.reduce((sum, item) => sum + item.totalClientes, 0);
      this.totalAberturaClientesValor = this.aberturaClientes.reduce((sum, item) => sum + item.valorFaturado, 0);
      this.aberturaClientesExibida = true;
      this.aberturaClientesCarregando = false;
    }, () => {
      if (consulta !== this.aberturaConsulta) return;
      this.aberturaClientesCarregando = false;
    });
  }

  private recolherAberturaClientes() {
    ++this.aberturaConsulta;
    this.aberturaClientesExibida = false;
    this.aberturaClientesCarregando = false;
    this.aberturaClientes = [];
    this.aberturaClientesAbertos = {};
    this.totalAberturaClientes = 0;
    this.totalAberturaClientesValor = 0;
  }

  vendedoresFiltrados(): Vendedor[] {
    const termo = this.normalizar(this.vendedorFiltro);

    return this.vendedores
      .filter(item => termo == '' || this.normalizar(item.fullname).indexOf(termo) > -1)
      .slice(0, 8);
  }

  clientesFiltrados(): Cliente[] {
    const termo = this.normalizar(this.clienteFiltro);

    return this.clientes
      .filter(item => {
        const nome = this.normalizar(item.name);
        const fantasia = this.normalizar(item.fantasia);
        const documento = this.normalizar(item.client_document);

        return termo == '' || nome.indexOf(termo) > -1 || fantasia.indexOf(termo) > -1 || documento.indexOf(termo) > -1;
      })
      .slice(0, 8);
  }

  produtosFiltrados(): Produto[] {
    const termo = this.normalizar(this.produtoFiltro);

    return this.produtosPesquisa
      .filter(item => {
        const nome = this.normalizar(item.name);
        const codigo = this.normalizar(item.codigo);

        return termo == '' || nome.indexOf(termo) > -1 || codigo.indexOf(termo) > -1;
      })
      .slice(0, 8);
  }

  selecionarVendedor(vendedor: Vendedor) {
    this.vendedorFiltro = vendedor.fullname || '';
    this.vendedorFiltroId = vendedor.id;
    this.filtroAtivo = '';
  }

  selecionarCliente(cliente: Cliente) {
    this.clienteFiltro = cliente.name || '';
    this.clienteFiltroId = cliente.client_id_app || cliente.id;
    this.filtroAtivo = '';
  }

  selecionarProduto(produto: Produto) {
    this.produtoFiltro = produto.name || produto.codigo || '';
    this.produtoFiltroId = produto.id;
    this.filtroAtivo = '';
  }

  alterarVendedorFiltro() {
    this.vendedorFiltroId = null;
  }

  alterarClienteFiltro() {
    this.clienteFiltroId = null;
  }

  alterarProdutoFiltro() {
    this.produtoFiltroId = null;
  }

  alterarGrupoFiltro() {
    this.grupo2Filtro = [];
    this.grupo3Filtro = [];
    this.atualizarOpcoesGruposLocal();
  }

  alterarGrupo2Filtro() {
    this.grupo3Filtro = [];
    this.atualizarOpcoesGruposLocal();
  }

  alterarGrupo3Filtro() {
    this.atualizarOpcoesGruposLocal();
  }

  abrirFiltroGrupo(tipo: string) {
    this.grupoFiltroAtivo = this.grupoFiltroAtivo == tipo ? '' : tipo;
  }

  fecharFiltroGrupo() {
    setTimeout(() => this.grupoFiltroAtivo = '', 160);
  }

  grupoSelecionado(tipo: string, valor: string): boolean {
    return this.getGrupoFiltro(tipo).indexOf(valor) > -1;
  }

  alternarGrupoSelecionado(tipo: string, valor: string, evento: Event) {
    evento.stopPropagation();

    const lista = this.getGrupoFiltro(tipo);
    const index = lista.indexOf(valor);

    if (index > -1) {
      lista.splice(index, 1);
    } else {
      lista.push(valor);
    }

    if (tipo == 'grupo') {
      this.alterarGrupoFiltro();
    } else if (tipo == 'grupo2') {
      this.alterarGrupo2Filtro();
    } else {
      this.alterarGrupo3Filtro();
    }
  }

  limparGrupoFiltro(tipo: string, evento: Event) {
    evento.stopPropagation();

    if (tipo == 'grupo') {
      this.grupoFiltro = [];
      this.alterarGrupoFiltro();
    } else if (tipo == 'grupo2') {
      this.grupo2Filtro = [];
      this.alterarGrupo2Filtro();
    } else {
      this.grupo3Filtro = [];
      this.alterarGrupo3Filtro();
    }
  }

  textoGrupoFiltro(tipo: string): string {
    const lista = this.getGrupoFiltro(tipo);

    if (!lista || lista.length == 0) {
      return 'Todos';
    }

    if (lista.length == 1) {
      return lista[0];
    }

    return `${lista.length} selecionados`;
  }

  alterarFiltroBase() {
    if (this.abaAtiva !== 'reativacoes') this.carregarFiltroGrupos();
    this.atualizar();
  }

  fecharPesquisa() {
    setTimeout(() => this.filtroAtivo = '', 160);
  }

  private formatarDataApi(data: Date): string {
    const ano = data.getFullYear();
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const dia = data.getDate().toString().padStart(2, '0');

    return `${ano}-${mes}-${dia}`;
  }

  private getPeriodoDescricao(): string {
    return `${this.formatarDataTela(this.dataInicio)} ate ${this.formatarDataTela(this.dataFim)}`;
  }

  private formatarDataTela(data: string): string {
    if (!data) {
      return '';
    }

    const partes = data.split('-');
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }

  private carregarOpcoesPesquisa() {
    this.vendedorService.getByUsuario().subscribe(retorno => this.vendedores = retorno || []);
    this.clienteService.getByUsuario(false).subscribe(retorno => this.clientes = retorno || []);
    this.produtoService.getByGuidClienteNapis().subscribe(retorno => this.produtosPesquisa = retorno || []);
  }

  private criarRequest(): DashboardResultadosRequest {
    return {
      userId: parseInt(localStorage.getItem('id')),
      dataInicio: this.dataInicio,
      dataFim: this.dataFim,
      ordenacaoProdutos: this.ordenacaoProdutos,
      ordenacaoClientes: this.ordenacaoClientes,
      ordenacaoCidades: this.ordenacaoCidades,
      tipoDados: this.tipoDados,
      codTipopedvenda: this.tipoPedidoFiltro || null,
      vendedor: this.vendedorFiltro,
      cliente: this.clienteFiltro,
      produto: this.produtoFiltro,
      grupo: '',
      grupo2: '',
      grupo3: '',
      grupos: this.grupoFiltro || [],
      grupos2: this.grupo2Filtro || [],
      grupos3: this.grupo3Filtro || [],
      sellerId: this.vendedorFiltroId,
      clienteId: this.clienteFiltroId,
      produtoId: this.produtoFiltroId
    };
  }

  private copiarRequest(request: DashboardResultadosRequest): DashboardResultadosRequest {
    return {
      ...request,
      grupos: [...(request.grupos || [])],
      grupos2: [...(request.grupos2 || [])],
      grupos3: [...(request.grupos3 || [])]
    };
  }

  private getGrupoFiltro(tipo: string): string[] {
    if (tipo == 'grupo') {
      return this.grupoFiltro;
    }

    if (tipo == 'grupo2') {
      return this.grupo2Filtro;
    }

    return this.grupo3Filtro;
  }

  private atualizarOpcoesGruposLocal() {
    const relacoesGrupo = this.gruposRelacoes.filter(item =>
      this.grupoFiltro.length == 0 || this.grupoFiltro.indexOf(item.grupo) > -1
    );

    this.grupos2Disponiveis = this.extrairValoresGrupo(relacoesGrupo.map(item => item.grupo2));

    this.grupo2Filtro = this.grupo2Filtro.filter(item => this.grupos2Disponiveis.indexOf(item) > -1);

    const relacoesGrupo2 = relacoesGrupo.filter(item =>
      this.grupo2Filtro.length == 0 || this.grupo2Filtro.indexOf(item.grupo2) > -1
    );

    this.grupos3Disponiveis = this.extrairValoresGrupo(relacoesGrupo2.map(item => item.grupo3));
    this.grupo3Filtro = this.grupo3Filtro.filter(item => this.grupos3Disponiveis.indexOf(item) > -1);
  }

  private extrairValoresGrupo(valores: string[]): string[] {
    return valores
      .filter(valor => !this.valorVazio(valor))
      .map(valor => valor.trim())
      .filter((valor, index, lista) => lista.indexOf(valor) == index)
      .sort((a, b) => a.localeCompare(b));
  }

  private valorVazio(valor: string): boolean {
    return valor == null || valor.toString().trim() == '';
  }

  private normalizar(valor: string): string {
    return (valor || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }
}
